import angular from 'angular';
import './bo-user-list.component.js';

(function() {
  'use strict';

  angular.module('app.bouser').config(routesConfig);

  routesConfig.$inject = ['$stateProvider'];

  /* @ngInject */
  function routesConfig($stateProvider) {
    $stateProvider
      .state('app.bouser', {
        abstract: true,
        component: 'contentLayout'
      })
      .state('app.bouser.list', {
        url: '/bo-user/list',
        views: {
          content: {
            component: 'bouserList'
          }
        },
        resolve: {
          boUsers: [
            'KissUserDA',
            function(KissUserDA) {
              return KissUserDA.getBoUsers();
            }
          ]
        },
        data: {
          authorizedRole: 'PRODUCT'
        }
      })
      .state('app.bouser.details', {
        url: '/bouser/{login}',
        views: {
          content: {
            component: 'bouserDetails'
          }
        },
        params: {
          login: null
        },
        resolve: {
          bouser: [
            '$transition$',
            'KissUserDA',
            function($transition$, KissUserDA) {
              if ($transition$.params().login) {
                return KissUserDA.getUserByLogin($transition$.params().login);
              }
            }
          ]
        },
        data: {
          authorizedRole: 'PRODUCT'
        }
      });
  }
})();
